import React, { useEffect, useState } from 'react';
import '@ant-design/compatible/assets/index.css';
import { Col, Row, Switch, Form } from 'antd';
import DF from 'DisplayFramework';
import FormInput from 'components/FormInput';
import TextArea from 'antd/lib/input/TextArea';

import { FormInstance } from 'antd/lib/form/Form';
import UsersInputByDepartment from 'pages/Collection/UsersInputByDepartment';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import { shouldUpdateCompare } from 'utils/utils2';

export type TabColCommentProps = {
  form?: FormInstance;
  objectid?: number;
  entityList?: Array<{ entityId: number }>;
};

const TabAssignManager = ({
  objectid,
  form,
  entityList,
}: TabColCommentProps) => {
  const [flagtrue, setflagtrue] = useState<boolean>(false);
  useEffect(() => {
    if (form) {
      form.setFieldsValue({
        useridtarget: Number(localStorage.getItem('userid')),
        flagAssignTome: true,
        flagAuto: true,
        flagRefresh: true,
        flagSendNotif: true,
        collist: entityList?.map((entity: any) => ({ colid: entity.entityId })),
       
      });
      setflagtrue(true)
    }
  }, [form]);
  

  return (
    <DF.Provider pagcode="TabAssignManager">
      <Row style={{ marginTop: '20px' }}>
        <Col span={24}>
          {/* to allow getfielvalue when no forminput exist */}
          <Form.Item name="collist" noStyle />
          <Form.Item name="useridtarget" noStyle />
          <Form.Item name="flagSendNotif" noStyle />
          <Row gutter={16}>
            <FormInput
              col
              xs={24}
              style={{ maxWidth: '50%' }}
              md={8}
              name="flagAssignTome"
              valuePropName="checked"
            >
              <Switch
                checkedChildren={<CheckOutlined />}
                unCheckedChildren={<CloseOutlined />}
                onChange={(e)=>{setflagtrue(e)}}
              />
            </FormInput>
            <Form.Item
              shouldUpdate={shouldUpdateCompare('flagAssignTome')}
              noStyle
            >
              {!flagtrue&&(
                <FormInput
                  col
                  xs={6}
                  name="useridtarget"
                  rules={[{ required: true }]}
                 
                  
                >
                  <UsersInputByDepartment
                    style={{ width: '100%' }}
                    allowClear
                    parentValue="RECO"
                  />
                </FormInput>
              )}
            </Form.Item>
          </Row>
          <Row gutter={16}>
            <FormInput
              col
              xs={24}
              style={{ maxWidth: '50%' }}
              md={8}
              name="flagRefresh"
              valuePropName="checked"
            >
              <Switch
                checkedChildren={<CheckOutlined />}
                unCheckedChildren={<CloseOutlined />}
              />
            </FormInput>
            <FormInput
              col
              xs={24}
              style={{ maxWidth: '50%' }}
              md={8}
              name="flagAuto"
              valuePropName="checked"
            >
              <Switch checkedChildren="yes" unCheckedChildren="no" />
            </FormInput>
            <Form.Item
              shouldUpdate={shouldUpdateCompare('flagAssignTome')}
              noStyle
            >
              {({ getFieldValue }) => (
                <FormInput
                  col
                  xs={24}
                  style={{ maxWidth: '50%' }}
                  md={8}
                  name="flagSendNotif"
                  valuePropName="checked"
                  hidden={!getFieldValue('flagAssignTome') === true}
                >
                  <Switch
                    checkedChildren="sendNotif"
                    unCheckedChildren="doNotSend"
                  />
                </FormInput>
              )}
            </Form.Item>
          </Row>

          <Row gutter={30}>
            <Col span={24}>
              <FormInput name="comment" rules={[{ required: true }]}>
                <TextArea maxLength={255} rows={5} cols={300} />
              </FormInput>
            </Col>
          </Row>
        </Col>
      </Row>
    </DF.Provider>
  );
};
export default TabAssignManager;
